export default {
    mobileScreenWidth: 991,    
    indentSmall: 8,
    indentMedium: 16,
    indentLarge: 32,
    indentXLarge: 64,
};
